'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dIngredient from "./mealorama.-Ingredient.js";
var $p;
/** @constructor */
function $c_Lmealorama_Ingredient$() {
}
export { $c_Lmealorama_Ingredient$ as $c_Lmealorama_Ingredient$ };
$p = $c_Lmealorama_Ingredient$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Ingredient$;
/** @constructor */
function $h_Lmealorama_Ingredient$() {
}
export { $h_Lmealorama_Ingredient$ as $h_Lmealorama_Ingredient$ };
$h_Lmealorama_Ingredient$.prototype = $p;
$p.m = (function() {
  return "Ingredient";
});
$p.aSj = (function(x$0) {
  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(0));
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(1));
  return new $j_mealorama$002e$002dIngredient.$c_Lmealorama_Ingredient($x_2.l, $x_2.h, $x_1.l, $x_1.h, x$0.g(2), x$0.g(3), x$0.g(4), x$0.g(5), x$0.g(6), x$0.g(7), (x$0.g(8) | 0), (!(!x$0.g(9))), x$0.g(10));
});
var $d_Lmealorama_Ingredient$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Ingredient$, "mealorama.Ingredient$", ({
  FU: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_Ingredient$ as $d_Lmealorama_Ingredient$ };
var $n_Lmealorama_Ingredient$;
function $m_Lmealorama_Ingredient$() {
  if ((!$n_Lmealorama_Ingredient$)) {
    $n_Lmealorama_Ingredient$ = new $c_Lmealorama_Ingredient$();
  }
  return $n_Lmealorama_Ingredient$;
}
export { $m_Lmealorama_Ingredient$ as $m_Lmealorama_Ingredient$ };
//# sourceMappingURL=mealorama.-Ingredient$.js.map
